module.exports = {
	"members": [
		{
			"name": "Rafał Krukowski",
			"description": "Jak zawsze niezdecydowany i bez grosza przy duszy. Na larpach woli stać w cieniu, nie lubi być w centrum uwagi. Na każdego larpa posiada milion planów na które i tak nie posiada sił ani środków. Rafał ma jedną zaletę, na prawie każdym larpie potrafi efektowanie zginąć. Poza larpem przywozi dobry bimber",
			"nick": "Sigwar",
			"img": "http://i.imgur.com/sbdCQWd.png"
		},
		{
			"name": "Szymon Gąsior",
			"description": "Z zawodu ratownik medyczny, na larpach oddaje się całym sobą dzięki czemu potrafi się wczuć w kazdą rolę. Ulubionym zajęciem Szymona jest gawędzenie z innymi graczami. Jest to postać bardzo charyzmatyczna, potrafi wcisnąć kit niejednej osobie. W wolnych chwilach przesiaduje w karczmie przepija albo przegrywa w pokera cały żołd.",
			"nick": "Aima",
			"img": "http://i.imgur.com/mXuWlkY.png"
		},
		{
			"name": "Patryk Konieczny",
			"description": "Założyciel grupy Krasja. Pracuje jako specjalista ds. technicznych w PCC Polska. Z pozoru łysy Kubuś puchatek, ale tylko z pozoru. Dzięki dużemu doświadczeniu Patryk lubi grać dowódce grupy. Zazwyczaj wszystko idzie po jego myśli, dopóki nie ma pieniędzy aby płacić żołd swoim żołnierzom",
			"nick": "Harun",
			"img": "http://i.imgur.com/u9cIRJy.png"
		},
		{
			"name": "Kacper Blak",
			"description": "Na larpach Kacper jest zwyczajnym graczem który w lewej ręce posiada fach a w prawej butelkę alkoholu. ",
			"nick": "Blaku",
			"img": "http://i.imgur.com/K1zeWgH.png"
		},
		{
			"name": "Kuba Bednarczuk",
			"description": "Jeden z młodszych członków grupy Krasja. Niech was nie zmyli ta słodka buźka, jeżeli zobaczycie krecącego się gdzieś Kube możecie podejrzewać go, że w swoijej kieszeni już ma wasze złoto. Na larpach nie ma  chyba lepszego złodzieja niż on. Jego gra polega na siedzeniu w karczmie i obmyślaniu planu jak ogołocić następną ofiarę.",
			"nick": "Amir",
			"img": "http://i.imgur.com/Amn4B4R.png"
		},
		{
			"name": "Paweł Kisiński",
			"description": "Drugi najmłodszy członek grupy Krasja. Paweł zazwyczaj trzyma się razem z Kubą. Razem tworzą niestabilną mieszankę która może w każdej chwili eksplodować. Na larpach Paweł wydaje się cichym graczem i taki właśnie jest. Nie zwraca na siebie uwagi jednak czasami podsłyszy przydatne informacje.",
			"nick": "Kwasior",
			"img": "http://i.imgur.com/Ruz7a1n.png"
		}
	],
	"events": [
		{
			"title": "Fort 2016",
			"fraction": " Łowcy nieumarłych",
			"target": " Wytropić grasującego w Ransfield nekromantę, oczyścić teren z żywych trupów. ",
			"description": "Fragment dziennika: Od przybycia do Ransfield zaczęły nawiedzać nas spętane duchy, widać nekromanta spodziewa się, że ktoś na niego poluje. Zwerbowałem w tej mieścinie kilkoro ludzi i tylko połowa przeżyła rytuał Dołaczenia. Sytuacja jest ciężka, może wręcz tragiczna. Jednak z gorszych opresji udawało się wychodzić obronną ręką.",
			"img": "http://i.imgur.com/geSDfhT.png"
		},
		{
			"title": "Fantazjada 2015",
			"fraction": "Południowy Emirat",
			"target": " Odzyskanie skradzionego przez Sabat amuletu.",
			"description": "Posłuchaj, dobra?! Mówię Ci! Gadałem z jednym z nich, szukają jakiegoś cholernego amuletu, Hans mówi, że nawet jakiegoś chłopa torturowali, chodzą wściekli na cały Einburg, każdemu zaglądają do kieszeni albo i głębiej! Jedynym plusem jest to, że zaciukali kilka bestyi, a i jakieś ichniejsze owoce nawieźli, całkiem to dobre!",
			"img": "http://i.imgur.com/jM9FDMC.png"
		},
		{
			"title": "Gothic 2014",
			"fraction": "Asasyni",
			"target": " Odnaleźć artefakt Beliara",
			"description": "Ja Imur'al Preslafa zaklinam was! Dzielny ludu Varrantu! Odnajdźcie w sobie odwagę i ruszajcie na wyspy Khorinis! Albowiem wielki Beliar objawił się dziś w nocy i objaśnił, że na wyspach znajduje się potężny artefakt, który winien spocząć w świątyni, w samym Ishtar! Zaś plugawi magowie ognia pragną położyć na nim swoje brudne łapska i go zniszczyć! Ruszajcie dzielny ludu Varrantu!",
			"img": "http://i.imgur.com/lmK1SYH.png"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./static/json/data.json
// module id = 3
// module chunks = 0